import { MfaSetupKey } from '@_types/shared/Mfa';
import { RootState } from '@reducers/index';

export const getMfaIsFetching = (state: RootState): boolean => state.mfaReducer.isFetching;
export const getMfaFetchError = (state: RootState): string | null => state.mfaReducer.fetchError;
export const getMfaSetupKey = (state: RootState): MfaSetupKey | null => state.mfaReducer.setupKey;
export const getMfaIsPosting = (state: RootState): boolean => state.mfaReducer.isPosting;
export const getMfaPostSuccess = (state: RootState): boolean => state.mfaReducer.postSuccess;
export const getMfaPostError = (state: RootState): string | null => state.mfaReducer.postError;
